import { Component, ViewContainerRef, TemplateRef } from '@angular/core';
import { Blog } from '../../models/blog/blog-model';
import { BlogCategory } from '../../models/blog/blog-category-model';
import { BlogCategoryService } from '../../services/blog/blog-category.service';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Http, Headers } from '@angular/http';
import { Router, ActivatedRoute } from '@angular/router';
import { ProfileService } from '../../services/profile/profile.service';
import { CategoryService } from '../../services/category/category.service';
import { MediaLibraryService } from '../../services/mediaLibrary/media-library.service';
import { MediaLibrary } from '../../models/mediaLibrary/media-library-model';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { RolePermissionService } from '../../services/role/role-permission.service';

@Component({
  selector: 'app-edit-blog',
  templateUrl: './edit-blog.component.html',
  styleUrls: ['./edit-blog.component.css']
})
/** edit-blog component*/
export class EditBlogComponent {
  /** edit-blog ctor */
  public blog= new Blog();
  fileToUpload: File;
  public mediaList: MediaLibrary[];
  fd = new FormData();
  blogCategoryId: string = "";
  selectedBlogLogo: string;
  editBlogLogo: string;
  mediaImageShow: boolean;
  public longDetail: any;
  public websiteName: string;
  userId: number;
  modalRef: BsModalRef;
  config = {
    animated: true
  };
  configuration = {
    uiColor: '#ffffff',
    toolbarGroups: [{ name: 'clipboard', groups: ['clipboard', 'undo'] },
    { name: 'editing', groups: ['find', 'selection', 'spellchecker'] },
    { name: 'links' }, { name: 'insert' },
    { name: 'document', groups: ['mode', 'document', 'doctools'] },
    { name: 'basicstyles', groups: ['basicstyles', 'cleanup'] },
    { name: 'paragraph', groups: ['list', 'indent', 'blocks', 'align'] },
    { name: 'styles' },
    { name: 'colors' }],
    resize_enabled: false,
    removePlugins: 'save',
    extraPlugins: 'smiley,justify,indentblock,colordialog',
    colorButton_foreStyle: {
      element: 'font',
      attributes: { 'color': '#(color)' }
    },
    height: 188,
    removeDialogTabs: '',
    removeButtons: '',
    format_tags: 'p;h1;h2;h3;pre;div'
  }
  isUnique = true;
  validate: boolean;
  public blogCategoryList: BlogCategory[];
  //public blogStatus: string[];
  public blogStatus: any[] = [];
  constructor(private _avRoute: ActivatedRoute, private _router: Router, public toastr: ToastsManager, vcr: ViewContainerRef,
    private readonly blogService: BlogCategoryService, private readonly categoryService: CategoryService, private readonly profileService: ProfileService,
    private readonly mediaServices: MediaLibraryService, private modalService: BsModalService, private readonly rolePermissionService: RolePermissionService) {

    this.checkPermission();
    this.blog.metaDescription = "";
    this.blog.metaTitle = "";
    this.blog.metaKeyword = "";
    if (this._avRoute.snapshot.params["id"]) {
      this.getBlogById(this._avRoute.snapshot.params["id"]);
      this.toastr.setRootViewContainerRef(vcr);
      this.blog.sortOrder = 0;
      this.validate = true;
      this.GetSystemSettingFirstOrDefault();
      this.GetBlogCategoryList();
    }
    this.profileService.getProfile().subscribe(
      data => {
        if (data) {
          this.blog.userId = data.userID;
          this.userId = data.userID;
        }
        else {
          this.blog.userId = 0;
        }
      });


  }
  checkPermission() {
    this.rolePermissionService.GetRolePermissions("blog").subscribe(
      data => {
        if (data != null) {

          var create = data.filter(function (element) {
            return (element.action == "edit");
          });

          if (create.length > 0) {
            
          }
          else {
            this._router.navigate(["/blog-list"]);
          }
        }
        else {
          this._router.navigate(["/blog-list"]);
        }
      }
    )
  }
  GetSystemSettingFirstOrDefault() {
    this.categoryService.GetSystemSettingFirstOrDefault().subscribe(
      data => {
        this.websiteName = data.siteUrl + "/blog";
      });
  }
  getBlogById(id: string) {
    this.blogService.getBlogById(id).subscribe(
      data => {
        this.blog = data;
        this.longDetail = this.blog.detail;
        if (this.blog.metaTitle == "" || this.blog.metaTitle ==null) {
          this.blog.metaTitle = "";
        }
        if (this.blog.metaKeyword == "" || this.blog.metaKeyword ==null) {
          this.blog.metaKeyword = "";
        }
        if (this.blog.metaDescription == "" || this.blog.metaDescription ==null) {
          this.blog.metaDescription = "";
        }
      }
    )
  }
  GetBlogCategoryList() {
    this.blogService.getBlogActiveCategory().subscribe(
      data => {
        if (data)
        this.blogCategoryList = data;
      }
    )
  }
  uploadBlogLogo(file: FileList) {
    this.selectedBlogLogo = "";
    this.fileToUpload = file.item(0);
    this.fd.append("BlogLogo", this.fileToUpload);
    ////Show image preview
    var reader = new FileReader();
    reader.onload = (event: any) => {
      this.blog.blogLogo = "";
      this.mediaImageShow = true;
      this.selectedBlogLogo = event.target.result;
    }
    reader.readAsDataURL(this.fileToUpload);
  }
  onTextChange(Value: string) {

    var i = 0, strLength = Value.length;
    for (i; i < strLength; i++) {
      Value = Value.replace(" ", "-");
    }
    this.blog.url = Value.toLowerCase();
  }
  onSubmit() {
    if (this.blog.sortOrder == null) {
      this.blog.sortOrder = 0;
    }
    this.blogService.isUniqueUrl(this.blog.url, this.blog.blogId).subscribe(
      data => {
        if (data == true) {
          this.isUnique = true;
          this.validate = false;
          this.blog.isActive = true;
          this.blog.detail = this.longDetail;
          this.blogService.updateBlog(this.blog).subscribe(result => {
            if (result) {
              this.toastr.success('Blog has been Updated. ', 'Success');
              this.fd.append("BlogId", result.toString());
              this.blogService.AddBlogLogo(this.fd, this.userId);
            }
            else {
              this.toastr.error('Error occurred. Oop!', 'Success');
            }
          });
        }
        else {
          this.isUnique = false;
        }
      });
  }
  OpenMediaPopup(template: TemplateRef<any>, ImageFor: string) {
    this.mediaServices.getMediaLibraryFor(ImageFor).subscribe(
      data => {
        this.mediaList = data;
        if (this.mediaList.length > 0) {
          this.modalRef = this.modalService.show(template, { class: 'modal-lg' });
        }
      }
    )
  }
  SlectImage(Image: MediaLibrary) {
    this.fileToUpload = null;
    this.fd = new FormData();
    this.editBlogLogo = Image.fileName;
    this.mediaList.forEach(x => {
      x.activeDiv = false;
    });
    Image.activeDiv = !Image.activeDiv;
  }

  ShowImage() {
    this.blog.blogLogo = this.editBlogLogo;
    this.selectedBlogLogo = "";
    this.modalRef.hide();
  }
  HidePopup() {

    this.editBlogLogo = "";
    this.modalRef.hide();
  }

}



// WEBPACK FOOTER //
// ./src/app/blog-components/edit-blog/edit-blog.component.ts